/**
 * Утилиты кабинета — повторяют хелперы из Android-приложения.
 */

/* ── цвет фона кружка-аватара по имени (детерминированно) ────────── */
// палитра из Android — 8 цветов, выбор по хешу имени
const AVATAR_COLORS = [
  "#EF4444",
  "#F59E0B",
  "#10B981",
  "#3B82F6",
  "#8B5CF6",
  "#EC4899",
  "#14B8A6",
  "#F97316",
];

export function avatarInitialColor(name) {
  const s = String(name || "?");
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

/* ── форматирование чисел ────────────────────────────────────────── */

/** 12345 → "12K", 1234567 → "1.2M", null → "—" */
export function formatCompact(n) {
  if (n == null) return "—";
  if (n < 1000) return String(n);
  if (n < 1_000_000) {
    const k = n / 1000;
    return k >= 10 ? `${Math.floor(k)}K` : `${k.toFixed(1).replace(/\.0$/, "")}K`;
  }
  return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
}

/* ── жанры: машинный код → русская подпись ───────────────────────── */
const GENRE_LABELS = {
  platformer: "Платформер",
  shooter: "Шутер",
  horror: "Хоррор",
  puzzle: "Головоломка",
  racing: "Гонки",
  adventure: "Приключения",
  rpg: "RPG",
  tycoon: "Тайкун",
  obby: "Обби",
  simulator: "Симулятор",
  action: "Экшен",
  other: "Игра",
};
export function genreLabel(genre) {
  return GENRE_LABELS[genre] || "Игра";
}

/* ── время ───────────────────────────────────────────────────────── */

/** "2026-05-07 09:30:41" → "07.05 09:30" */
export function formatActivityTime(raw) {
  if (!raw) return "";
  const parts = String(raw).split(/[ T]/);
  const time = (parts[1] || "").slice(0, 5);
  const date = parts[0] || "";
  const [, mon, day] = date.split("-");
  return day && mon ? `${day}.${mon} ${time}` : raw;
}

/** "2026-05-07 09:30:41" → "сегодня HH:MM" / "D мес" */
export function formatChatTime(raw) {
  if (!raw) return "";
  const parts = String(raw).split(/[ T]/);
  const date = parts[0] || "";
  const time = (parts[1] || "").slice(0, 5);
  const today = new Date().toISOString().slice(0, 10);
  if (date === today) return time;
  const [, m, d] = date.split("-");
  const months = [
    "янв", "фев", "мар", "апр", "май", "июн",
    "июл", "авг", "сен", "окт", "ноя", "дек",
  ];
  const mi = parseInt(m, 10) - 1;
  return d && mi >= 0 ? `${parseInt(d, 10)} ${months[mi]}` : raw;
}

/** "2026-05-01" → "Май 2026" (для архива битвы рейтингов, формат "YYYY-MM"). */
export function formatMonthYear(raw) {
  if (!raw) return "";
  const [y, m] = String(raw).split("-");
  const months = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
  ];
  const mi = parseInt(m, 10) - 1;
  return y && mi >= 0 ? `${months[mi]} ${y}` : raw;
}

/** Дней до конца текущего месяца (для «До итогов: N дней»). */
export function daysToMonthEnd() {
  const now = new Date();
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  return lastDay - now.getDate();
}

/** Склонение «день/дня/дней». */
export function pluralDays(n) {
  const a = n % 10;
  const b = n % 100;
  if (b >= 11 && b <= 14) return "дней";
  if (a === 1) return "день";
  if (a >= 2 && a <= 4) return "дня";
  return "дней";
}

/** "2026-05-01 05:55:12" → "1 мая, 05:55" (для комментариев). */
export function formatCommentDate(raw) {
  if (!raw) return "";
  const parts = String(raw).split(/[ T]/);
  const date = parts[0] || "";
  const time = (parts[1] || "").slice(0, 5);
  const [, m, d] = date.split("-");
  const months = [
    "января", "февраля", "марта", "апреля", "мая", "июня",
    "июля", "августа", "сентября", "октября", "ноября", "декабря",
  ];
  const mi = parseInt(m, 10) - 1;
  return d && mi >= 0 ? `${parseInt(d, 10)} ${months[mi]}, ${time}` : raw;
}

/** "2026-05-14 18:54:35" → "14.05.2026" (дата создания/обновления игры). */
export function formatDateDMY(raw) {
  if (!raw) return "";
  const date = String(raw).split(/[ T]/)[0] || "";
  const [y, m, d] = date.split("-");
  if (!y || !m || !d) return raw;
  return `${d.padStart(2, "0")}.${m.padStart(2, "0")}.${y}`;
}

/** Миллисекунды → "12.34 с" или "1:02.34" (для лидербордов игр). */
export function formatLeaderboardTime(ms) {
  if (ms == null) return "—";
  const totalSec = ms / 1000;
  if (totalSec < 60) return `${totalSec.toFixed(2)} с`;
  const min = Math.floor(totalSec / 60);
  const sec = (totalSec % 60).toFixed(2).padStart(5, "0");
  return `${min}:${sec}`;
}
